import { createAccessLatch } from "@/shared/utils/accessLatch";

/**
 * Session-scoped access latch shared by every read of this surface.
 *
 * A missing `payments:read` role surfaces as a **401** (the RBAC guard throws Unauthorized, not Forbidden)
 * and every 401 costs a silent `/auth/refresh` + replay inside `HttpApiService`. The explorer and the ledger
 * pane hit the same permission, so one denial must silence both for the rest of the session instead of each
 * hook re-discovering it on every query change.
 *
 * Read it with {@link ledgerAccessLatch.useDenied}, never by copying the answer into `useState` — see
 * `@/shared/utils/accessLatch` for why the copy goes stale.
 */
export const ledgerAccessLatch = createAccessLatch();
